import React, { useState } from 'react';
import { TIPOS_GROUPED, ORIENTACIONES } from '../data/orientaciones';
import OrientacionPanel from '../components/OrientacionPanel';
import ColegioSelector from '../components/ColegioSelector';

const ROLES = ['Propietario / Titular','Director(a) docente','Secretario(a) docente','Padre / Madre / Tutor','Estudiante','Personal administrativo','Otro'];

export default function NuevoCaso({ onGuardar, onCancel }) {
  const [form, setForm] = useState({ codigoCentro:'', centro:'', solicitante:'', rol:ROLES[0], telefono:'', email:'', fecha:new Date().toISOString().split('T')[0], tipo:'', descripcion:'', destinatario:'', estado:'Recibido', fechaAlerta:'' });
  const [esNuevo, setEsNuevo] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const set = (k,v) => setForm(f=>({...f,[k]:v}));

  async function handleSubmit(e) {
    e.preventDefault();
    if ((!form.codigoCentro&&!esNuevo)||(esNuevo&&!form.centro)||!form.solicitante||!form.tipo) {
      setError('Completa los campos obligatorios: colegio, solicitante y tipo de caso.'); return;
    }
    setSaving(true);
    try {
      await onGuardar({ ...form, seguimientos:[], creadoEn:new Date().toISOString() });
      setForm({ codigoCentro:'', centro:'', solicitante:'', rol:ROLES[0], telefono:'', email:'', fecha:new Date().toISOString().split('T')[0], tipo:'', descripcion:'', destinatario:'', estado:'Recibido', fechaAlerta:'' });
      setEsNuevo(false); setError('');
    } catch { setError('Error al guardar. Intenta de nuevo.'); }
    setSaving(false);
  }

  return (
    <div>
      <div style={{ marginBottom:14, display:'flex', gap:10, alignItems:'center' }}>
        <button className="btn btn-sm" onClick={onCancel}>← Cancelar</button>
      </div>
      <div className="card" style={{ maxWidth:760 }}>
        <div className="card-header"><h3>Registrar nuevo caso</h3></div>
        <div className="card-body">
          {error && <div style={{ background:'var(--red-light)',border:'1px solid #fca5a5',borderRadius:8,padding:'10px 14px',fontSize:13,color:'var(--red)',marginBottom:16 }}>{error}</div>}
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Colegio *</label>
                <ColegioSelector value={form.codigoCentro} nombreValue={form.centro} esNuevo={esNuevo}
                  onToggleNuevo={v=>{setEsNuevo(v);setForm(f=>({...f,codigoCentro:'',centro:''}));}}
                  onChange={(codigo,nombre)=>setForm(f=>({...f,codigoCentro:codigo,centro:nombre}))}
                />
                {form.codigoCentro&&form.codigoCentro!=='NUEVO'&&<div style={{fontSize:11,color:'var(--minerd-green-dk)',marginTop:4,fontWeight:600}}>Código SIGERD: {form.codigoCentro}</div>}
                {esNuevo&&<div style={{fontSize:11,color:'#b45309',marginTop:4,fontWeight:600,background:'#fffbeb',padding:'3px 8px',borderRadius:5,display:'inline-block'}}>Apertura — sin código SIGERD aún</div>}
              </div>
              <div className="form-group"><label>Fecha *</label><input type="date" value={form.fecha} onChange={e=>set('fecha',e.target.value)}/></div>
            </div>
            <div className="form-row">
              <div className="form-group"><label>Solicitante *</label><input value={form.solicitante} onChange={e=>set('solicitante',e.target.value)} placeholder="Nombre completo"/></div>
              <div className="form-group"><label>Rol del solicitante</label><select value={form.rol} onChange={e=>set('rol',e.target.value)}>{ROLES.map(r=><option key={r}>{r}</option>)}</select></div>
            </div>
            <div className="form-row">
              <div className="form-group"><label>Teléfono</label><input value={form.telefono} onChange={e=>set('telefono',e.target.value)} placeholder="809-000-0000"/></div>
              <div className="form-group"><label>Correo</label><input type="email" value={form.email} onChange={e=>set('email',e.target.value)} placeholder="correo@ejemplo.com"/></div>
            </div>
            <div className="form-group">
              <label>Tipo de caso *</label>
              <select value={form.tipo} onChange={e=>{set('tipo',e.target.value);if(ORIENTACIONES[e.target.value])set('destinatario',ORIENTACIONES[e.target.value].encargado);}}>
                <option value="">— Seleccionar tipo de caso —</option>
                {TIPOS_GROUPED.map(g=><optgroup key={g.group} label={g.group}>{g.options.map(o=><option key={o.value} value={o.value}>{o.label}</option>)}</optgroup>)}
              </select>
            </div>
            <div className="form-group"><label>Descripción</label><textarea value={form.descripcion} onChange={e=>set('descripcion',e.target.value)} placeholder="Resumen de lo que plantea el solicitante..."/></div>
            <div className="form-row">
              <div className="form-group"><label>Enviado / Remitido a</label><input value={form.destinatario} onChange={e=>set('destinatario',e.target.value)} placeholder="Instancia o persona responsable"/></div>
              <div className="form-group"><label>Fecha límite / Alerta</label><input type="date" value={form.fechaAlerta} onChange={e=>set('fechaAlerta',e.target.value)}/></div>
            </div>
            {form.tipo && <OrientacionPanel tipo={form.tipo}/>}
            <div style={{ display:'flex', gap:10, marginTop:16 }}>
              <button type="submit" className="btn btn-primary" disabled={saving}>{saving?'Guardando...':'Guardar caso'}</button>
              <button type="button" className="btn" onClick={()=>{setForm({codigoCentro:'',centro:'',solicitante:'',rol:ROLES[0],telefono:'',email:'',fecha:new Date().toISOString().split('T')[0],tipo:'',descripcion:'',destinatario:'',estado:'Recibido',fechaAlerta:''});setEsNuevo(false);}}>Limpiar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
